import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";

function ProductionEntry() {
    const extractArray = (response) => {
        if (Array.isArray(response?.data)) return response.data;
        if (Array.isArray(response?.Data)) return response.Data;
        return [];
    };
    const navigate = useNavigate();
    const location = useLocation();
    const [formData, setFormData] = useState({
        CreditNote_ID: "",
        date: new Date(),
        customer: JSON.parse(localStorage.getItem("Login"))?.Customer_Code,
        noteNo: "",
        docketNo: "",
        parti: "",
        remark: "",
        amount: "",
    });
    const [getCustomer, setGetCustomer] = useState([]);
   

    const loginCustomerCode = JSON.parse(localStorage.getItem("Login"))?.Customer_Code;
    const allCust =
        JSON.parse(localStorage.getItem("Login"))?.UserType === "Admin"
            ?
            [
                ...getCustomer.map((cust) => ({
                    label: cust.Customer_Name,
                    value: cust.Customer_Code,
                })),
            ]
            :
            Array.isArray(getCustomer) && getCustomer.length > 0
                ? getCustomer
                    .filter(cust => cust.Customer_Code === loginCustomerCode)
                    .map(cust => ({
                        label: cust.Customer_Name,
                        value: cust.Customer_Code,

                    }))
                : []

    
    const [creditNotes, setCreditNotes] = useState([]);
    const [openRow, setOpenRow] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = creditNotes?.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(creditNotes?.length / rowsPerPage);
    function formatDateToYMD(dateStr) {
        if (!dateStr) return "";

        const [dd, mm, yyyy] = dateStr.split("/");

        return `${yyyy}-${mm}-${dd}`;
    }

    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
    // 🔄 Fetch helper
    const fetchData = async (endpoint, setData) => {
        try {
            const response = await getApi(endpoint);
            setData(extractArray(response));
        } catch (err) {
            console.error("Fetch Error:", err);
        }
    };

    // 🧠 Load Customers and Credit Notes
    useEffect(() => {
        fetchData("/Master/getCustomerdata", setGetCustomer);
        fetchCreditNotes();
    }, []);

    // 🧾 Get All Credit Notes
    const fetchCreditNotes = async () => {
        try {
            const res = await getApi("/Smart/GetAllCreditNotes");
            setCreditNotes(extractArray(res));
        } catch (err) {
            console.error("Fetch Credit Notes Error:", err);
        }
    };

    // ✍️ Handle input changes
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // 🔁 Reset form
    const handleReset = () => {
        setFormData({
            CreditNote_ID: "",
            date: new Date(),
            customer:  JSON.parse(localStorage.getItem("Login"))?.Customer_Code,
            noteNo: "",
            docketNo: "",
            parti: "",
            remark: "",
            amount: "",
        });
        setIsEditMode(false);
        setOpenRow(null);
    };

    // 💾 ADD / SAVE Credit Note
    const handleSave = async (e) => {
        e.preventDefault();
        if (!formData.customer || !formData.date || !formData.noteNo) {
            return Swal.fire("Warning", "Customer ,Date and Docket No is required", "warning");
        }


        const payload = {
            Note_No: formData.noteNo,
            Docket_No: formData.docketNo,
            Note_Date: (formData.date),
            Customer_Code: String(formData.customer),
            Particulars: formData.parti,
            Remark: formData.remark,
            Amount: parseFloat(formData.amount),
        };

        try {
            const response = await postApi("/Smart/AddCreditNote", payload, "POST");
            Swal.fire("Success", response.message || "Credit Note Added Successfully", "success");
            handleReset();
            await fetchCreditNotes();
        } catch (err) {
            console.error("Save Error:", err);
            Swal.fire("Error", err.message || "Failed to save credit note", "error");
        }
    };

    // 🧰 UPDATE Credit Note
    const handleUpdate = async (e) => {
        e.preventDefault();

        if (!formData.CreditNote_ID) {
            Swal.fire("Warning", "Please select a record to update", "warning");
            return;
        }

        const payload = {
            CreditNote_ID: formData.CreditNote_ID,
            Note_No: formData.noteNo,
            Docket_No: formData.docketNo,
            Note_Date: (formData.date),
            Customer_Code: formData.customer,
            Particulars: formData.parti,
            Remark: formData.remark,
            Amount: parseFloat(formData.amount),
            User: formData.user
        };

        try {
            const response = await postApi("/Smart/UpdateCreditNote", payload);
            Swal.fire("Updated", response.message || "Credit Note Updated Successfully", "success");
            handleReset();
            await fetchCreditNotes();
        } catch (err) {
            console.error("Update Error:", err);
            Swal.fire("Error", err.message || "Failed to update credit note", "error");
        }
    };

    // ❌ DELETE Credit Note
    const handleDelete = async (CreditNote_ID) => {
        setOpenRow(null);
        const confirm = await Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the credit note.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!"
        });

        if (!confirm.isConfirmed) return;

        try {
            const response = await postApi(`/Smart/DeleteCreditNote?CreditNote_ID=${CreditNote_ID}`);
            Swal.fire("Deleted!", response.message || "Credit Note Deleted Successfully", "success");
            handleReset();
            fetchCreditNotes();
        } catch (err) {
            console.error("Delete Error:", err);
            Swal.fire("Error", err.message || "Failed to delete credit note", "error");
        }
    };

    // 🖱️ Populate form when row clicked
    const handleRowClick = (note) => {
        setFormData({
            CreditNote_ID: note.CreditNote_ID,
            date: formatDateToYMD(note.Note_Date),
            customer: note.Customer_Code,
            noteNo: note.Note_No,
            docketNo: note?.Docket_No,
            parti: note.Particulars,
            remark: note.Remark,
            amount: note.Amount,
        });
        setOpenRow(null);
        setIsEditMode(true);
    };
    const handleOpenCreditPrint = (CreditNote_ID) => {
        navigate("/creditprint", { state: { CreditNote_ID: CreditNote_ID, from: location.pathname, tab: "creditNote" } })
    };
    return (
        <>
            <div className="body">
                <div className="container1">
                    <form onSubmit={handleSave} >
                        <div className="fields2" >
                            <div className="input-field1">
                                <label>Customer Name</label>
                                <Select
                                    options={allCust}  // [{value: "", label: "All Customers"}, ...]
                                    value={
                                        allCust.find((c) => c.value === formData.customer) || null
                                    }
                                    onChange={(selectedOption) =>
                                        setFormData({
                                            ...formData,
                                            customer: selectedOption ? selectedOption.value : ""
                                        })
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                        container: (base) => ({ ...base, width: "100%" }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                    placeholder="Select Customer"
                                    isSearchable
                                    classNamePrefix="blue-selectbooking"
                                    className="blue-selectbooking"
                                />
                            </div>

                            <div className="input-field3">
                                <label>Note Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.date}
                                    onChange={(date) => setFormData({ ...formData, date })}
                                    dateFormat="dd/MM/yyyy"
                                    
                                />
                            </div>

                            <div className="input-field3">
                                <label>Invoice No</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="Enter invoice no"
                                    name="noteNo"
                                    value={formData.noteNo}
                                    onChange={handleFormChange}
                                />
                            </div>

                            <div className="input-field3">
                                <label>Docket No</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="Enter docket no"
                                    name="docketNo"
                                    value={formData.docketNo}
                                    onChange={handleFormChange}
                                />
                            </div>

                            <div className="input-field3">
                                <label>Item Name</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="Enter item name"
                                    name="parti"
                                    value={formData.parti}
                                    onChange={handleFormChange}
                                />
                            </div>

                            <div className="input-field3">
                                <label>Amount</label>
                                <input
                                    type="number"
                                    className="input"
                                    placeholder="Enter amount"
                                    name="amount"
                                    value={formData.amount}
                                    onChange={handleFormChange}
                                />
                            </div>


                            <div className="input-field3">
                                <label>Remark</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="Enter remark"
                                    name="remark"
                                    value={formData.remark}
                                    onChange={handleFormChange}
                                />
                            </div>

                               <div className="bottom-buttons" style={{ marginTop: "23px", marginLeft: "10px" }}>
                                    {!isEditMode && (<button className="ok-btn" onClick={handleSave}>
                                        Save
                                    </button>)}
                                    {isEditMode && (<button type="button" className="ok-btn" onClick={handleUpdate}>
                                        Update
                                    </button>)}
                                    <button className="ok-btn" type="button" onClick={handleReset}>
                                        Cancel
                                    </button>
                                </div>
                        </div>
                    </form>


                    {/* TABLE */}
                    <div className="table-container">
                        <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                            <thead className="table-head">
                                <tr>
                                    <th className="w-60">Actions</th>
                                    <th className="w-60">ID</th>
                                    <th>Docket No</th>
                                    <th>Invoice No</th>
                                    <th>Note Date</th>
                                    <th>Customer Name</th>
                                    <th>Item Name</th>
                                    <th>Remark</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((note, index) => (
                                    <tr
                                        key={note.CreditNote_ID}
                                        style={{ fontSize: "12px", position: "relative" }}
                                    >
                                        <td className="w-60">
                                            <PiDotsThreeOutlineVerticalFill
                                                style={{ fontSize: "20px", cursor: "pointer" }}
                                                onClick={() => setOpenRow(openRow === index ? null : index)}
                                            />
                                            {openRow === index && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        flexDirection: "row",
                                                        position: "absolute",
                                                        alignItems: "center",
                                                        left: "80px",
                                                        top: "0px",
                                                        borderRadius: "10px",
                                                        backgroundColor: "white",
                                                        zIndex: "999999",
                                                        height: "30px",
                                                        width: "50px",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <button className='edit-btn' onClick={() => handleOpenCreditPrint(note.CreditNote_ID)} >
                                                        <i className='bi bi-file-earmark-pdf-fill' style={{ fontSize: "18px" }}></i>
                                                    </button>
                                                    <button className="edit-btn">
                                                        <i className="bi bi-pen" style={{ fontSize: "15px" }} onClick={() => handleRowClick(note)}></i>
                                                    </button>
                                                    <button onClick={() => handleDelete(note.CreditNote_ID)} className="edit-btn">
                                                        <i className="bi bi-trash" style={{ fontSize: "15px" }}></i>
                                                    </button>
                                                </div>
                                            )}
                                        </td>
                                        <td className="w-60">{note.CreditNote_ID}</td>
                                        <td>{note?.Docket_No}</td>
                                        <td>{note.Note_No}</td>
                                        <td>{note.Note_Date}</td>
                                        <td>{note.Customer_Name}</td>
                                        <td>{note.Particulars}</td>
                                        <td>{note.Remark}</td>
                                        <td>{note.Amount}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="row" style={{ whiteSpace: "nowrap" }}>
                        <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                {'<'}
                            </button>
                            <span style={{ color: "#333", padding: "5px" }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                {'>'}
                            </button>
                        </div>

                        <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                            <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                            <select
                                id="rowsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                style={{ height: "40px", width: "50px" }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProductionEntry;
